import { render, staticRenderFns } from "./FullLinkReceiver.vue?vue&type=template&id=5ca3c8d0"
import script from "./FullLinkReceiver.vue?vue&type=script&lang=ts"
export * from "./FullLinkReceiver.vue?vue&type=script&lang=ts"
import style0 from "../../scss/grid.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./FullLinkReceiver.vue?vue&type=style&index=1&id=5ca3c8d0&prod&lang=css"
import style2 from "../../scss/base.scss?vue&type=style&index=2&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports